import labels from './labels';
import defaultTokenSource from './token-source';

export default {
  settings: {
    languageId: 'en-US',
    currencyId: 'USD',
    environment: 'uat',
    tokenSource: defaultTokenSource.name,
    SATokenSourceOptions: defaultTokenSource,
    hypoFileType: 0,
    portfolios: null,
    riskModelId: 'morn-glb-ma-usd',
    initialInvestmentAmount: 100000,
    colors: ['#1f55a5', '#ef7622', '#a50032', '#518428', '#f5c400', '#e5e5e5'],
    showMacroShockScenarios: false,
    showMarketShockScenarios: false,
  },
  components: {
    mwcPpScenarioAnalysis: {
      type: 'mwcPpScenarioAnalysis',
      version: '*',
      blueprint: 'standardUs',
    },
  },
  labels: {
    en: labels['en-US'],
    ...labels,
  },
};
